import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { calculatePaymentInstallment } from 'modules/accommodations/features/reservations/api';

export const useMutationCalculatePaymentInstallment = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(calculatePaymentInstallment, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_CALCULATE_PAYMENT_INSTALLMENT);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_CALCULATE_PAYMENT_INSTALLMENT);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage);
    },
  });

  return {
    calculatePaymentMutate: mutateAsync,
    calculatePaymentLoading: isLoading,
    calculatePaymentError: isError,
    calculatedPaymentData: data,
  };
};
